<script setup lang="ts">
import NrIcon from '@nextrequestco/components/src/components/NrIcon'
import { Account } from './app_header.vue'

const { account, getNavbarItemClassName, handleNavigate } = defineProps<{
  account: Account
  getNavbarItemClassName: (route: any) => any
  handleNavigate: (event: PointerEvent, routerNavFunction: any) => void
}>()
</script>

<template>
  <div
    v-if="
      account.published_custom_forms &&
      account.published_custom_forms.length > 1
    "
    class="navbar-item has-dropdown is-hoverable"
  >
    <span class="navbar-link navbar-icon-desktop"> Make request </span>
    <span class="navbar-link navbar-icon-mobile">
      <NrIcon name="clipboard-list" class="icon navbar-icon-mobile" />
      Make request
    </span>
    <div class="navbar-dropdown is-right is-boxed">
      <router-link
        v-for="form in account.published_custom_forms"
        :key="form.slug"
        :to="`/requests/new/${form.slug}`"
        v-slot="{ href, navigate }"
        custom
      >
        <a
          :href="href"
          class="navbar-item"
          @click="handleNavigate($event, navigate)"
        >
          {{ form.name }}
        </a>
      </router-link>
    </div>
  </div>
  <router-link
    v-else
    :to="`/requests/new${
      account.published_custom_forms
        ? '/' + account.published_custom_forms[0].slug
        : ''
    }`"
    v-slot="{ href, route, navigate }"
    custom
  >
    <div :class="getNavbarItemClassName(route)">
      <a :href="href" @click="handleNavigate($event, navigate)">
        Make request
      </a>
    </div>
  </router-link>
</template>

<style scoped lang="scss">
@import '../../../styles/globals.scss';
$navbar-breakpoint: $tablet;
@import 'bulma/bulma.sass';
</style>
